import { createSlice } from "@reduxjs/toolkit";

const popupSlice = createSlice({
  name: "popup",
  initialState: {
    spotifyReconnect: false,
  },
  reducers: {
    showSpotifyReconnect: (state) => {
      state.spotifyReconnect = true;
    },
    hideSpotifyReconnect: (state) => {
      state.spotifyReconnect = false;
    },
  },
});

export const { showSpotifyReconnect, hideSpotifyReconnect } = popupSlice.actions;
export default popupSlice.reducer;
